export const setTypes = (state, types) => { state.types = types }
export const setChapters = (state, chapters) => { state.chapters = chapters }
export const setTaskChapters = (state, chapters) => { state.taskChapters = chapters }
export const setTaskStatuses = (state, statuses) => { state.taskStatuses = statuses }
export const setTaskMandatory = (state, mandatory) => { state.taskMandatory = mandatory }
export const setTaskAssignee = (state, users) => { state.taskAssignee = users }
export const setAdminUsers = (state, users) => { state.adminUsers = users }
export const setTags = (state, tags) => { state.tags = tags }
export const setCategories = (state, categories) => { state.categories = categories }

// auth
export const authLogin = state => { state.auth.pending = true }
export const setUserDimensions = (state) => {
  if (window._paq) {
    let userData = JSON.parse(localStorage.getItem('userData'))
    let industryName = localStorage.getItem('userIndustryName')
    let userCompanyName = localStorage.getItem('userCompanyName')
    if (industryName) {
      window._paq.push(['setCustomDimension', 5, industryName])
    }
    if (userCompanyName) {
      window._paq.push(['setCustomDimension', 6, userCompanyName])
    }
    if (userData) {
      window._paq.push(['setUserId', userData.id])
      window._paq.push(['setCustomDimension', 7, userData.userRole])
    }
  }
}
export const resetUserDimensions = (state) => {
  if (window._paq) {
    window._paq.push(['deleteCustomDimension', 5])
    window._paq.push(['deleteCustomDimension', 6])
    window._paq.push(['deleteCustomDimension', 7])
    window._paq.push(['resetUserId'])
  }
}
export const authLoginSuccess = (state) => {
  // state.auth.isLoggedIn = true
  // state.auth.pending = false
  this.setUserDimensions(state)
  if (window._paq) {
    window._paq.push(['trackEvent', 'Login', 1])
  }
  // if (window.ga) {
  //   window.ga('send', {
  //     hitType: 'event',
  //     eventCategory: 'Login',
  //     eventValue: 1
  //   })
  // }
}
export const authLoginSetUsername = (state, name) => { state.auth.username = name }
export const authLoginSetUserRole = (state, userRole) => { state.auth.userRole = userRole }
export const setProfile = (state, profile) => { state.profile = profile }
export const authLoginSetCompany = (state, company) => { state.auth.company = company }
export const authLogout = state => {
  state.auth.isLoggedIn = false
  state.auth.username = null
  state.auth.userRole = null
  this.resetUserDimensions(state)
  if (window._paq) {
    window._paq.push(['trackEvent', 'Logout', 1])
  }
  // if (window.ga) {
  //   window.ga('send', {
  //     hitType: 'event',
  //     eventCategory: 'Logout',
  //     eventValue: 1
  //   })
  // }
}

export const setActions = (state, actions) => { state.actions = actions }
export const setRoles = (state, roles) => { state.roles = roles }

// Companies
export const setCompanies = (state, payload) => { state.companies = payload }

// Industries
export const setIndustries = (state, payload) => { state.industries = payload }

// Default Registration Roles
export const setDefaultRegistrationRoles = (state, payload) => { state.defaultRegistrationRoles = payload }

// Sponsors
export const setSponsors = (state, payload) => { state.sponsors = payload }

//
export const setDataPreviewArticle = (state, payload) => { state.articlePreview = payload }
// Lngs
export const setLanguages = (state, payload) => { state.languages = payload }
export const setCompanySizes = (state, payload) => { state.companySizes = payload }
export const setCompanyLocations = (state, payload) => { state.companyLocations = payload }
export const setCompanyOrganizationTypes = (state, payload) => { state.companyOrganizationTypes = payload }
export const initConfAction = (state, payload) => {
  state.confData.id = payload.id
  state.confData.actionId = payload.actionId
  state.confData.actionName = payload.actionName
  state.confData.showPopup = true
  state.confData.userStatus = payload.userStatus
  state.confData.actionConfirmed = payload.confirmActionHandler
  state.confData.includeForm = payload.includeForm
  state.confData.customCancelButtonText = payload.customCancelButtonText
  state.confData.customConfirmButtonText = payload.customConfirmButtonText
  state.confData.feedbackText = payload.feedbackText
  state.confData.customText = payload.customText
}

export const clearConfAction = (state, payload) => {
  state.confData.id = null
  state.confData.actionName = null
  state.confData.showPopup = false
  state.confData.actionId = null
  state.confData.userStatus = null
  state.confData.feedbackText = null
  state.confData.customText = null
  state.confData.includeForm = null
  state.confData.customCancelButtonText = null
  state.confData.customConfirmButtonText = null
}

// Information block mutation
export const setInformationMsg = (state, payload) => {
  state.informationMsg.isShown = payload.isShown
  state.informationMsg.title = payload.title
  state.informationMsg.text = payload.text
  for (let className in state.informationMsg.className) {
    state.informationMsg.className[className] = false
  }
  if (payload.className) {
    state.informationMsg.className[payload.className] = true
  }
  document.body.scrollTop = document.documentElement.scrollTop = 0
  setTimeout(() => {
    state.informationMsg.isShown = false
    state.informationMsg.title = ''
    state.informationMsg.text = ''
  }, 15000)
}

export const setStyleForMsg = (state, payload) => {
  state.informationMsg.style = payload
}

export const resizeText = (state, payload) => {
  let fontSizeButtons = document.getElementsByClassName('text-resize-controls__button')
  let fontSizeTrigger = document.getElementById('accessibilityFontSize_' + payload)
  for (let i = 0; i < fontSizeButtons.length; i++) {
    fontSizeButtons[i].classList.remove('active')
  }
  switch (payload) {
    case 0:
      document.getElementsByTagName('HTML')[0].style.fontSize = '100%'
      break
    case 1:
      document.getElementsByTagName('HTML')[0].style.fontSize = '110%'
      break
    case 2:
      document.getElementsByTagName('HTML')[0].style.fontSize = '120%'
      break
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-size-0', 'accessibility-size-1', 'accessibility-size-2')
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-size-' + payload)
  if (fontSizeTrigger) {
    fontSizeTrigger.classList.add('active')
  }
  state.specialOps.selectedFont = payload
  localStorage.setItem('selectedFont', payload)
}

export const changeVisibilityThem = (state, payload) => {
  let colorPaletteButtons = document.getElementsByClassName('color-change-controls__button')
  for (let i = 0; i < colorPaletteButtons.length; i++) {
    colorPaletteButtons[i].classList.remove('active')
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-color-0', 'accessibility-color-1', 'accessibility-color-2')
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-color-' + payload)
  document.getElementById('accessibilityColorPalette_' + payload).classList.add('active')
  state.specialOps.selectedHightCont = payload
  localStorage.setItem('selectedHightCont', payload)
}

export const changeConsent = (state, payload) => {
  state.consentRequired = payload
  localStorage.setItem('consentHead', payload)
}

export const changeImpersonate = (state, payload) => {
  state.impersonatingUser = payload
  if (!payload) {
    localStorage.removeItem('impersonated')
    location.href = '/admin'
    let app = document.getElementById('app')
    if (app) {
      app.removeAttribute('data-industry')
    }
  }
}

export const changeAuthUserData = (state, payload) => {
  state.auth.userData = payload
}

export const changeUserRole = (state, payload) => {
  state.auth.userData.userRole = payload
}

export const setBacklogTasks = (state, payload) => {
  state.tasks.backlogTasks = []
  for (let i = 0; i < payload.length; i++) {
    state.tasks.backlogTasks = [
      ...state.tasks.backlogTasks,
      ...payload[i].tasks
    ]
  }
}

export const setFocusTasks = (state, payload) => {
  state.tasks.focusTasks = []
  for (let i = 0; i < payload.length; i++) {
    state.tasks.focusTasks = [
      ...state.tasks.focusTasks,
      ...payload[i].tasks
    ]
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js